import React from 'react';
import { PanelHeader } from 'js/components';
import { Breadcrumbs } from 'js/components/Breadcrumbs';
import { useParams } from 'react-router-dom';
import RubricTabs from './RubricTabs';

function RubricPageLayout({ rubric, rubricLoadFailed, children = null }) {
  const { workspaceId } = useParams();
  const rubricTitle = rubric?.name || 'Rubric';
  const rubricLoading = !rubric && !rubricLoadFailed;
  const rubricError = rubricLoadFailed && !rubric;

  const breadcrumbs = [{ label: 'Rubrics', to: `/w/${workspaceId}/rubrics` }];

  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className="content-fluid">
            <h1>{rubricLoading ? 'Loading rubric…' : rubricTitle}</h1>
            {rubricError && (
              <p className="text-danger mb-0">
                Unable to load this rubric. It may not exist.
              </p>
            )}
          </div>
        </div>
        <div className="container-fluid">
          <RubricTabs />
        </div>
      </PanelHeader>
      <div className="content">{children}</div>
    </div>
  );
}

export default RubricPageLayout;
